module.exports = __webpack_public_path__ + "img/sort.46f97848.svg";